import { deleteData } from '../backend';
import { useModal } from '../contexts';
import { useState } from 'react';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

interface Props {
  workflowIds: Array<string>;
  onCompletion: () => void;
}

function WorkflowModalDeleteBatch(props: Props) {
  const { workflowIds } = props;
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const [progress, setProgress] = useState<number>(0);

  async function handleConfirm() {
    setProgress(1);

    for (const workflowId of workflowIds) {
      await deleteData(`/workflows/${workflowId}/`)
        .catch((error) => { console.log(error) });

      setProgress((progress) => progress + 1);
    }

    closeModal(props.onCompletion);
  }

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-bold text-red text-xl">
          {t("Delete")} {props.workflowIds.length} {t("Workflows")}
        </h3>
      }
      subtitle={`${t("Are you sure you would like the delete")} ${props.workflowIds.length > 1 ? t('these workflows?') : t('this workflow?')} ${t("This action cannot be undone.")}`}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
      primaryButtonProps={{ className: "btn-red", text: "Confirm", onClick: () => handleConfirm(), disabled: progress > 0 }}
      size='sm'>
      <div className="font-semibold text-gray-400 text-sm">
        {progress >= 1
          ? <>{t("Deleting")} {progress} {t("of")} {workflowIds.length} {t("workflows...")}</>
          : <>&nbsp;</>
        }
      </div>
    </Modal>
  );
}

export default WorkflowModalDeleteBatch;
